import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal } from "../../../components/ui";

/**
 * Delete confirmation for a role. When the role still has assigned users the
 * deletion is blocked: the message explains why and the confirm button is
 * disabled (per the story, deletion is not allowed while No. of Users > 0).
 */
const DeleteRoleModal = ({ open, role, copy, onClose, onConfirm }) => {
  const usersCount = role?.usersCount || 0;
  const isBlocked = usersCount > 0;
  const roleName = role?.name ?? "";
  const message = isBlocked
    ? copy.blockedMessage
        .replace("{role}", roleName)
        .replace("{count}", usersCount)
    : copy.question.replace("{role}", roleName);

  return (
    <UIActionModal
      open={open}
      onClose={onClose}
      title={copy.title}
      variant="reject"
      maxWidth="sm"
      PaperProps={{ className: "team-management-delete-modal" }}
      actions={
        <UIActionModal.Actions
          cancelLabel={copy.cancel}
          confirmLabel={copy.delete}
          confirmVariant="reject"
          confirmDisabled={isBlocked}
          onCancel={onClose}
          onConfirm={onConfirm}
        />
      }
    >
      <Typography className="team-management-delete-modal__message">
        {message}
      </Typography>
    </UIActionModal>
  );
};

DeleteRoleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  role: PropTypes.shape({
    name: PropTypes.string,
    usersCount: PropTypes.number,
  }),
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    blockedMessage: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    delete: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DeleteRoleModal.defaultProps = {
  role: null,
};

export default DeleteRoleModal;
